/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserAttributes
 */
export interface UserAttributes {
    /**
     * 
     * @type {string}
     * @memberof UserAttributes
     */
    fbclid?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAttributes
     */
    sendSiteAccessEmail?: boolean;
    /**
     * Device platform (iOS or Android)
     * @type {string}
     * @memberof UserAttributes
     */
    devicePlatform?: string;
    /**
     * iOS Identifier for Vendors (required for iOS)
     * @type {string}
     * @memberof UserAttributes
     */
    deviceIdfv?: string;
    /**
     * iOS Identifier for Advertisers (optional, only if ATT granted)
     * @type {string}
     * @memberof UserAttributes
     */
    deviceIdfa?: string;
    /**
     * Android Google Advertising ID / GAID (required for Android)
     * @type {string}
     * @memberof UserAttributes
     */
    deviceAifa?: string;
    /**
     * Android App Set ID (required for Android)
     * @type {string}
     * @memberof UserAttributes
     */
    deviceAsid?: string;
    /**
     * OS version (e.g., "17.0" or "14.0")
     * @type {string}
     * @memberof UserAttributes
     */
    deviceOsVersion?: string;
    /**
     * Bundle ID (iOS) or Package Name (Android)
     * @type {string}
     * @memberof UserAttributes
     */
    deviceAppIdentifier?: string;
    /**
     * iOS ATT status (0=undetermined, 1=restricted, 2=denied, 3=authorized)
     * @type {number}
     * @memberof UserAttributes
     */
    deviceAttStatus?: number;
    /**
     * Last known IP address of the device
     * @type {string}
     * @memberof UserAttributes
     */
    deviceIpAddress?: string;
}

/**
 * Check if a given object implements the UserAttributes interface.
 */
export function instanceOfUserAttributes(value: object): value is UserAttributes {
    return true;
}

export function UserAttributesFromJSON(json: any): UserAttributes {
    return UserAttributesFromJSONTyped(json, false);
}

export function UserAttributesFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAttributes {
    if (json == null) {
        return json;
    }
    return {
        
        'fbclid': json['fbclid'] == null ? undefined : json['fbclid'],
        'sendSiteAccessEmail': json['send_site_access_email'] == null ? undefined : json['send_site_access_email'],
        'devicePlatform': json['device_platform'] == null ? undefined : json['device_platform'],
        'deviceIdfv': json['device_idfv'] == null ? undefined : json['device_idfv'],
        'deviceIdfa': json['device_idfa'] == null ? undefined : json['device_idfa'],
        'deviceAifa': json['device_aifa'] == null ? undefined : json['device_aifa'],
        'deviceAsid': json['device_asid'] == null ? undefined : json['device_asid'],
        'deviceOsVersion': json['device_os_version'] == null ? undefined : json['device_os_version'],
        'deviceAppIdentifier': json['device_app_identifier'] == null ? undefined : json['device_app_identifier'],
        'deviceAttStatus': json['device_att_status'] == null ? undefined : json['device_att_status'],
        'deviceIpAddress': json['device_ip_address'] == null ? undefined : json['device_ip_address'],
    };
}

export function UserAttributesToJSON(json: any): UserAttributes {
    return UserAttributesToJSONTyped(json, false);
}

export function UserAttributesToJSONTyped(value?: UserAttributes | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fbclid': value['fbclid'],
        'send_site_access_email': value['sendSiteAccessEmail'],
        'device_platform': value['devicePlatform'],
        'device_idfv': value['deviceIdfv'],
        'device_idfa': value['deviceIdfa'],
        'device_aifa': value['deviceAifa'],
        'device_asid': value['deviceAsid'],
        'device_os_version': value['deviceOsVersion'],
        'device_app_identifier': value['deviceAppIdentifier'],
        'device_att_status': value['deviceAttStatus'],
        'device_ip_address': value['deviceIpAddress'],
    };
}

